// Free Gift Cart Reconciliation (cart page only)
// 1) Remove orphan free gifts (no parent mattress)
// 2) Add missing gifts when an eligible mattress is in cart

(function () {
  var CONFIG_SELECTOR = '.js-free-gift-config';
  var PRODUCT_SELECTOR = '.js-free-gift-product';
  var VARIANT_SELECTOR = '.js-free-gift-variant';
  var HAS_FREE_GIFT_FLAG = '_Has Free Gift';
  var FREE_GIFT_FLAG = '_Free Gift';
  var TIMESTAMP_PROP = '_timestamp';
  var PARENT_LINE_KEY_PROP = '_free_gift_parent_line_key';
  var RUN_LOCK_KEY = 'free_gift_reconcile_lock_v1';
  var RUN_LOCK_TIMEOUT_MS = 30000;

  function getNowMs() {
    return new Date().getTime();
  }

  function acquireRunLock() {
    try {
      if (window.__freeGiftReconcileRunning) return false;
      window.__freeGiftReconcileRunning = true;
      var existing = window.sessionStorage && window.sessionStorage.getItem(RUN_LOCK_KEY);
      if (existing) {
        var ts = parseInt(existing, 10);
        if (!isNaN(ts) && (getNowMs() - ts) < RUN_LOCK_TIMEOUT_MS) return false;
      }
      if (window.sessionStorage) window.sessionStorage.setItem(RUN_LOCK_KEY, String(getNowMs()));
      return true;
    } catch (e) {
      if (window.__freeGiftReconcileRunning) return false;
      window.__freeGiftReconcileRunning = true;
      return true;
    }
  }

  function releaseRunLock() {
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(RUN_LOCK_KEY);
    } catch (e) {}
    window.__freeGiftReconcileRunning = false;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('Failed to load cart');
      return res.json();
    });
  }

  function cartUpdate(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to update cart');
      return res.json();
    });
  }

  function cartAdd(items) {
    if (!items || !items.length) return Promise.resolve(null);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to add free gift');
      return res.json();
    });
  }

  function cartChange(lineKey, quantity, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity, properties: properties })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to change cart line');
      return res.json();
    });
  }

  // Free gift is valid only if a non-gift parent shares its timestamp (or parent line key)
  function getOrphanGiftKeys(items) {
    var parentKeys = {};
    var parentTimestamps = {};

    (items || []).forEach(function (item) {
      var p = item.properties || {};
      if (p[FREE_GIFT_FLAG] === 'Yes') return;
      parentKeys[item.key] = true;
      if (p[TIMESTAMP_PROP]) parentTimestamps[p[TIMESTAMP_PROP]] = true;
    });

    return (items || []).filter(function (item) {
      var p = item.properties || {};
      if (p[FREE_GIFT_FLAG] !== 'Yes') return false;
      if (p[PARENT_LINE_KEY_PROP] && parentKeys[p[PARENT_LINE_KEY_PROP]]) return false;
      if (p[TIMESTAMP_PROP] && parentTimestamps[p[TIMESTAMP_PROP]]) return false;
      return true;
    }).map(function (item) {
      return item.key;
    });
  }

  function removeOrphanGifts(items) {
    var keys = getOrphanGiftKeys(items);
    if (!keys.length) return Promise.resolve(false);
    var updates = {};
    keys.forEach(function (key) { updates[key] = 0; });
    return cartUpdate(updates).then(function () { return true; });
  }

  function getMatchingGiftVariantId(scopeEl, mainVariantTitle) {
    var spans = Array.prototype.slice.call(scopeEl.querySelectorAll(VARIANT_SELECTOR));
    if (!spans.length) return null;

    if (!mainVariantTitle) {
      var first = spans.find(function (el) {
        var a = el.getAttribute('data-variant-available');
        return a === 'true' || a === 'True' || a === '1';
      });
      return (first || spans[0]).getAttribute('data-variant-id');
    }

    var selectedTitle = mainVariantTitle.split('/')[0].trim().toLowerCase().replace(/\(.*?\)/, '').trim();
    var queenSizes = ['twin', 'twin xl', 'full', 'queen', 'split king (order 2 to make a set)'];
    var pillowSize = queenSizes.indexOf(selectedTitle) > -1 ? 'queen' : 'king';

    function titleOf(el) {
      return (el.getAttribute('data-variant-title') || '').trim().toLowerCase();
    }

    var exact = spans.find(function (el) { return titleOf(el) === selectedTitle; });
    if (exact) return exact.getAttribute('data-variant-id');

    try {
      var re = new RegExp('\\b' + selectedTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i');
      var boundary = spans.find(function (el) { return re.test(titleOf(el)); });
      if (boundary) return boundary.getAttribute('data-variant-id');
    } catch (e) {}

    try {
      var pillowRe = new RegExp('\\b' + pillowSize + '\\b', 'i');
      var pillow = spans.find(function (el) { return pillowRe.test(titleOf(el)); });
      if (pillow) return pillow.getAttribute('data-variant-id');
    } catch (e) {}

    var available = spans.find(function (el) {
      var a = el.getAttribute('data-variant-available');
      return a === 'true' || a === 'True' || a === '1';
    });
    return (available || spans[0]).getAttribute('data-variant-id');
  }

  function getGiftVariantIds(configEl, mainVariantTitle) {
    var productEls = Array.prototype.slice.call(configEl.querySelectorAll(PRODUCT_SELECTOR));
    if (!productEls.length) {
      var single = getMatchingGiftVariantId(configEl, mainVariantTitle);
      return single ? [single] : [];
    }
    var ids = [];
    productEls.forEach(function (el) {
      var id = getMatchingGiftVariantId(el, mainVariantTitle);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function buildGiftItems(configEl, mainVariantTitle, firstAttr, secondAttr, parentLineKey, sharedTs) {
    var productEls = Array.prototype.slice.call(configEl.querySelectorAll(PRODUCT_SELECTOR));
    var ts = sharedTs || new Date().toISOString();
    var scopes = productEls.length ? productEls : [configEl];
    var items = [];

    scopes.forEach(function (scopeEl, idx) {
      var id = getMatchingGiftVariantId(scopeEl, mainVariantTitle);
      if (!id) return;
      var props = {};
      props[FREE_GIFT_FLAG] = 'Yes';
      props[TIMESTAMP_PROP] = ts;
      if (parentLineKey) props[PARENT_LINE_KEY_PROP] = parentLineKey;
      if (idx === 0 && firstAttr) props[firstAttr] = 'Yes';
      if (idx === 1 && secondAttr) props[secondAttr] = 'Yes';
      items.push({ id: Number(id), quantity: 1, properties: props });
    });

    return items;
  }

  function reconcileFreeGifts() {
    if (!acquireRunLock()) return;

    fetchCart()
      .then(function (cart) {
        var items = (cart && cart.items) || [];

        // Step 1: never leave free gifts alone / unlinked
        return removeOrphanGifts(items).then(function (purged) {
          if (purged) return fetchCart().then(function (c) {
            return { items: (c && c.items) || [], changed: true };
          });
          return { items: items, changed: false };
        });
      })
      .then(function (state) {
        var items = state.items;
        var hadChanges = state.changed;
        var configEls = Array.prototype.slice.call(document.querySelectorAll(CONFIG_SELECTOR));
        var chain = Promise.resolve();

        // Step 2: for each eligible mattress, add missing gifts (if not already flagged)
        configEls.forEach(function (el) {
          chain = chain.then(function () {
            var lineKey = el.getAttribute('data-line-key');
            if (!lineKey) return;

            var mainItem = items.find(function (ci) { return ci.key === lineKey; });
            if (!mainItem) return;

            var props = mainItem.properties || {};
            var flagged = props[HAS_FREE_GIFT_FLAG] === 'Yes' ||
              (el.getAttribute('data-has-free-gift') || '').toLowerCase() === 'yes';

            var mainTitle = el.getAttribute('data-main-variant-title') || '';
            var giftIds = getGiftVariantIds(el, mainTitle);
            if (!giftIds.length) return;

            var existingIds = {};
            items.forEach(function (ci) {
              var p = ci.properties || {};
              if (p[FREE_GIFT_FLAG] !== 'Yes') return;
              if (p[PARENT_LINE_KEY_PROP] === lineKey ||
                  (props[TIMESTAMP_PROP] && p[TIMESTAMP_PROP] === props[TIMESTAMP_PROP])) {
                existingIds[String(ci.variant_id)] = true;
              }
            });

            var missing = giftIds.filter(function (id) { return !existingIds[String(id)]; });
            if (!missing.length) {
              if (!flagged) {
                hadChanges = true;
                var ts = props[TIMESTAMP_PROP] || new Date().toISOString();
                var nextProps = JSON.parse(JSON.stringify(props));
                nextProps[HAS_FREE_GIFT_FLAG] = 'Yes';
                nextProps[TIMESTAMP_PROP] = ts;
                return cartChange(lineKey, mainItem.quantity || 1, nextProps);
              }
              return;
            }

            // Already has gifts handled and complete
            if (flagged) return;

            hadChanges = true;
            var timestamp = props[TIMESTAMP_PROP] || new Date().toISOString();
            var firstAttr = (el.getAttribute('data-first-free-gift-attribute') || '').trim();
            var secondAttr = (el.getAttribute('data-second-free-gift-attribute') || '').trim();
            var toAdd = buildGiftItems(el, mainTitle, firstAttr, secondAttr, lineKey, timestamp)
              .filter(function (gi) { return missing.indexOf(String(gi.id)) > -1; });

            return cartAdd(toAdd).then(function () {
              var nextProps = JSON.parse(JSON.stringify(props));
              nextProps[HAS_FREE_GIFT_FLAG] = 'Yes';
              nextProps[TIMESTAMP_PROP] = timestamp;
              return cartChange(lineKey, mainItem.quantity || 1, nextProps);
            });
          });
        });

        return chain.then(function () {
          if (hadChanges) {
            window.location.reload();
            return;
          }
          releaseRunLock();
        });
      })
      .catch(function () {
        releaseRunLock();
      });
  }

  // Before checkout: strip orphan gifts, then go to /checkout
  // (form.submit() alone skips name="checkout" and stays on /cart — that broke the button)
  function bindCheckoutGuard() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], .cart-checkout button[name="checkout"]');
      if (!btn) return;
      if (window.__freeGiftCheckoutGuardRunning) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      window.__freeGiftCheckoutGuardRunning = true;

      fetchCart()
        .then(function (cart) {
          return removeOrphanGifts((cart && cart.items) || []);
        })
        .then(function () {
          window.__freeGiftCheckoutGuardRunning = false;
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.__freeGiftCheckoutGuardRunning = false;
          window.location.href = '/checkout';
        });
    }, true);
  }

  onReady(function () {
    bindCheckoutGuard();
    reconcileFreeGifts();
  });
})();
